import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/branding';
import { ResultState } from '@rootCommon/types/common';
import { BrandingFile } from '@rootCommon/types/branding';

type Action = ActionType<typeof actions>;
export type BrandingFilesState = ResultState<BrandingFile[] | null>;

const initState: BrandingFilesState = {
  data: null,
  loading: false,
  error: null,
};

export const brandingFilesReducer = (state = initState, action: Action): BrandingFilesState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchBrandingFiles.request):
      return { ...state, loading: true };
    case getType(actions.fetchBrandingFiles.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchBrandingFiles.failure):
      return { ...state, loading: false, error: action.payload };

      // create
    case getType(actions.createBrandingFile.request):
      return { ...state, loading: true };
    case getType(actions.createBrandingFile.success):
      return { ...state, loading: false, data: [...(state.data || []), action.payload] };
    case getType(actions.createBrandingFile.failure):
      return { ...state, loading: false, error: action.payload };

      // delete
    case getType(actions.deleteBrandingFile.request):
      return { ...state, loading: true };
    case getType(actions.deleteBrandingFile.success):
      return { ...state, loading: false, data: state.data?.filter((file) => file.id !== action.payload) || null };
    case getType(actions.deleteBrandingFile.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default brandingFilesReducer;
